import HomePage from "@/components/pages/Home.vue";
import GamesPage from "@/components/pages/Games.vue";
import PopularGamesPage from "@/components/pages/PopularGames.vue";
import NewGamesPage from "@/components/pages/NewGames.vue";
import FavoritesPage from "@/components/pages/Favorites.vue";
import SearchPage from "@/components/pages/Search.vue";
import RecentViewPage from "@/components/pages/RecentView.vue";
import LoginPage from "@/components/pages/Login.vue";
import RegisterPage from "@/components/pages/Register.vue";
import PaymentFeedback from "@/components/pages/payment/PaymentFeedback.vue";
import NotFound from "@/components/pages/404.vue";
import Subscribe from "@/components/pages/Subscribe.vue";
import GamePage from "@/components/pages/Game.vue";
import Unsubscribe from "@/components/pages/Unsubscribe.vue";
import Profile from "@/components/pages/Profile.vue";
import Terms from "@/components/pages/Terms.vue";
import Privacy from "@/components/pages/Privacy.vue";
import Leaderboard from "@/components/pages/Leaderboard.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
    meta: { 
      title: ("Home"),
      description: ('Explore the Mars gaming platform and start wonderful games!'),
    },
  },
  {
    path: "/games",
    name: "games",
    component: GamesPage,
    meta: { 
      title: ("Games"),
      description: ('Dive into an exciting games on Mars.'),
    },
  },
  {
    path: '/game/:slug',
    name: 'game.show',
    meta: {
      title: ('Game'),
      description: ('Dive into an exciting game experience on Mars.'),
    },
    component: GamePage,
  },
  {
    path: "/search",
    name: "search",
    component: SearchPage,
    meta: { 
      title: ("Search Result"),
      description: ('Find the best gaming titles, tailored to your interests. Explore detailed reviews, top picks, and trending games all in one place!'),
    },
  },
  {
    path: "/popular-games",
    name: "popular-games",
    component: PopularGamesPage,
    meta: { 
      title: ("Popular Games"),
      description: ('Dive into an exciting game experience on Mars.'),
    },
  },
  {
    path: "/new-games",
    name: "new-games",
    component: NewGamesPage,
    meta: { 
      title: ("New Games"),
      description: ('Dive into an exciting game experience on Mars.'),
    },
  },
  {
    path: "/favorites",
    name: "favorites",
    component: FavoritesPage,
    meta: { 
      title: ("Favorites"), 
      description: ('Dive into an exciting game experience on Mars.'),
      requiresAuth: true,
    },
  },
  {
    path: "/recent-view",
    name: "recent-view",
    component: RecentViewPage,
    meta: { 
      title: ("Recent View"),
      description: ('Dive into an exciting game experience on Mars.'),
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginPage,
    meta: { 
      title: ("Login"), 
      description: 'Log in to your Mars account and continue the fun!',
    },
  },
  {
    path: "/register",
    name: "user.register",
    component: RegisterPage,
    meta: { 
      title: ("Register"), 
      description: 'Log in to your Mars account and continue the fun!',
    },
  },
  {
    path: '/subscribe',
    name: 'subscribe.page',
    component: Subscribe,
    meta: { 
      title: ('Subscribe'), 
      description: '',
    },
  },
  {
    path: '/payment-feedback/:status',
    name: 'payment.feedback',
    meta: {
        title: 'Payment Feedback',
        description: '',
    },      
    component: PaymentFeedback,
  },
  {
    path: '/unsubscribe',
    name: 'unsubscribe.page',
    component: Unsubscribe,
    meta: { 
      title: ('UnSubscribe'),
      description: '',
    },
  },
  {
    path: '/profile',
    name: 'profile.page',
    component: Profile,
    meta: { 
      title: ('Profile'),
      description: '',
      requiresAuth: true,
    },
  },
  {
    path: '/terms',
    name: 'terms.page',
    component: Terms,
    meta: { 
      title: ('Term of use'),
      description: 'Review our terms and conditions to use Mars responsibly.',
    },
  },
  {
    path: '/privacy',
    name: 'privacy.page',
    component: Privacy,
    meta: { 
      title: ('Privacy policy'),
      description: 'Read our policies to understand how Mars works.',
    },
  },
  {
    path: '/leaderboard',
    name: 'leaderboard.page',
    component: Leaderboard,
    meta: { 
      title: ('Leaderboard'),
      description: '',
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: { 
      title: ("404 Not Found"), 
      description: '',
    },
  },
];

export default routes;
